import React from 'react';
import Home from './Home';
import ReactDOM from "react-dom";
import {BrowserRouter, Switch, Route, Redirect} from 'react-router-dom';
import IndexPage from './IndexPage'; // Create this component for the source URL
import Contact from './Contact';
import About from './About';
import Services from './Services';
import Event from './Event';
import TechnicalSupport from './TechnicalSupport';
import Terms from './Terms';
import Career from './Career';
import Privacy from './Privacy';
import Category from './Category';
import Search from './Search';
import Detail from './Detail';
import AllPhotos from './AllPhotos';
import AllEvents from './AllEvents'
import Login from './Login'
import Stories from './Stories'
import '../css/style.css';


const App = () =>{
  return(
    <>
    <BrowserRouter>
      <Switch>
        <Route exact path="/" component={Home}/>
        {/* <Route exact path="/all-photos" component={AllPhotos}/>
        <Route exact path="/stories" component={Stories}/>
        <Route exact path="/all-events" component={AllEvents}/>
        <Route exact path="/all-events/:offset" component={AllEvents}/>
        <Route exact path="/all-photos/:offset" component={AllPhotos}/>
        <Route exact path="/search/:offset" component={Search}/>
        <Route exact path="/contact-us" component={Contact}/>
        <Route exact path="/services" component={Services}/>
        <Route exact path="/technical-support" component={TechnicalSupport}/>
        <Route exact path="/about-us" component={About}/>
        <Route exact path="/terms-of-use" component={Terms}/>
        <Route exact path="/career" component={Career}/>
        <Route exact path="/login" component={Login}/>
        <Route exact path="/privacy-policy" component={Privacy}/>
        <Route exact path="/category/:categoryId" component={Category}/>
        <Route exact path="/category/:categoryId/:offset" component={Category}/>
        <Route exact path="/detail/:newsId" component={Detail}/>
        <Route exact path="/event/:newsId" component={Event}/>
        <Route path="/index.php" component={IndexPage} /> */}
        <Redirect to="/" />
      </Switch>
    </BrowserRouter>
    </>
  )
}

export default App;
